import React, { useEffect, useState } from "react";
import { postProcedimientoVias } from "../../../services/PaginaRuta";
import ModalConfirmarEliminarUnProcedimiento from "./ModalConfirmarEliminarUnProcedimiento";
//import ModalEliminarProcedimiento from "./ModalEliminarProcedimiento";
import ModalProcedimientosDeCirugia from "./ModalProcedimientosDeCirugia";

const TablaProcedimiento = ({ item, passActualizarTablaProcedimiento,user }) => {
    const [modalOnProcedimientoCirugia, setModalOnProcedimientoCirugia] = useState(false)
    const [modalOnProcedimientoEliminar, setmodalOnProcedimientoEliminar]=useState(false)
    const [vias,setvias]=useState('')
    
    const handleOnclickEliminarProcedimiento=()=>{
      setmodalOnProcedimientoEliminar(true)
    }

    const passActua=(data)=>{
      passActualizarTablaProcedimiento(data)
    }

    const handleClickModificar = ()=>{
        setModalOnProcedimientoCirugia(true)
    }

    useEffect(()=>{
    const via={
      ViaCod:item.ViaCod
    }
    postProcedimientoVias(via).then((res)=>{
      setvias(res.data[0].ViaDsc)
      //console.log(item.ViaCod,'viaaaa')
    })
  },[item.ViaCod])

    

  return (
    <>
    <tbody>
      <tr className=" divide-y divide-slate-700 ">
        <td></td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">
          <button
            type="button"
            onClick={handleClickModificar}
            className="inline-block px-3 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
          >
            Modificar 
          </button>
        </td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">
          <button
            type="button"
            onClick={handleOnclickEliminarProcedimiento}
            className="inline-block px-3 py-1.5 bg-red-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-red-700 hover:shadow-lg focus:bg-red-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-red-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
          >
            Eliminar 
          </button>
        </td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">
          {item.CrgCod}
        </td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap text-left">
          {item.CrgDes}
        </td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">
          {item.CrgCnt}
        </td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">
          
          {vias}
        </td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">
          {item.MedCod}
        </td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap text-left">
          {item.MedNom}
        </td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">
          {item.EspcCod}
        </td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">
          {item.EspcDes}
        </td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">
          {item.CrgHnrCi}
        </td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">
          {item.CrgHnCiD}
        </td>
      </tr>
      {modalOnProcedimientoCirugia? <ModalProcedimientosDeCirugia setModalOnProcedimientoCirugia={setModalOnProcedimientoCirugia} item={item} passActua={passActua} user={user}/>:null}
      {/* {modalOnProcedimientoEliminar? <ModalEliminarProcedimiento setmodalOnProcedimientoEliminar={setmodalOnProcedimientoEliminar}/>:null} */}
      {modalOnProcedimientoEliminar? <ModalConfirmarEliminarUnProcedimiento setmodalOnProcedimientoEliminar={setmodalOnProcedimientoEliminar} item={item} passActua={passActua}/>:null}
      </tbody>
    </>

  );
};

export default TablaProcedimiento;
